import { companyDashboardRoute } from '@/abilities/companyDashboard/routes';
import { toCompanyDashboardDestination } from '@/abilities/companyDashboard/vocabulary';
import { createDestinationRoute } from '@/router/destinationRoute';
import { companyDashboardDestinationRoutes } from '@/pages/company/DashboardRoute/destinationRoutes';

export const companyDashboardDestinationRoute = createDestinationRoute(
  companyDashboardDestinationRoutes,
  toCompanyDashboardDestination,
  companyDashboardRoute,
);
